// extracted by mini-css-extract-plugin
export default {"option":"style_option__EfVNH","label":"style_label__HsmCq"};